/** @format */

import React, { useState, useLayoutEffect } from 'react';
import { Button } from '@base-components';

/**
 * Scroll Button.
 */

/**
 * Back to Top.
 */
const BackToTop = (): JSX.Element => {
  const [visible, setVisible] = useState(true);

  /**
   * Scroll To Top.
   */
  const scrollToTop = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ): void => {
    event.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  /**
   * Toggle Visible.
   */
  const toggleVisible = (): void => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300) {
      setVisible(true);
    } else if (scrolled <= 300) {
      setVisible(false);
    }
  };

  /**
   * Setup window event listener.
   */
  useLayoutEffect(() => {
    window.addEventListener('scroll', toggleVisible);
  }, []);

  /**
   * Render.
   */
  return (
    <Button
      dataButtonType="control"
      dataButtonVariation="outline"
      onButtonClick={(event) => scrollToTop(event)}
      additionalClasses={visible ? `show-button back-to-top` : `back-to-top`}
    >
      <i className="icon-arrow-right-medium"></i>
    </Button>
  );
};
export default BackToTop;
